import { render, staticRenderFns } from "./CallFeeCommission.vue?vue&type=template&id=934d508a&scoped=true"
import script from "./CallFeeCommission.vue?vue&type=script&lang=js"
export * from "./CallFeeCommission.vue?vue&type=script&lang=js"
import style0 from "./CallFeeCommission.vue?vue&type=style&index=0&id=934d508a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934d508a",
  null
  
)

export default component.exports